import React from "react";
import { downloadAuthedFile } from "components/common/services/apiUtils";
import Button from "components/common/atoms/Button";
import CheckBoxField from "components/common/atoms/CheckBoxField";
import { t } from "components/CentralDataMangement/translation/Translation";

interface ActionButtonsSectionProps {
  isAuthenticated: boolean;
  isTermsAccepted: boolean;
  changeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  employerModal: () => void;
  sendToEmployerModal: () => void;
  handleSubmit: (sendToEmployer: boolean) => void;
  agreementId: string;
  adminFicheId: string;
  langKey: string | number | boolean | object;
  isEmployer: boolean;
  isFeeBased: string | null;
  handleSendToBright: () => void;
  handleUpload: () => void;
  isSubmit: boolean;
  handleNext: (showExplicitRegime: boolean, type: string) => void;
}

const ActionButtonsSection: React.FC<ActionButtonsSectionProps> = ({
  isAuthenticated,
  isTermsAccepted,
  changeHandler,
  employerModal,
  handleSubmit,
  sendToEmployerModal,
  agreementId,
  langKey,
  isEmployer,
  adminFicheId,
  isFeeBased,
  handleSendToBright,
  handleUpload,
  isSubmit,
  handleNext,
}) => {
  return (
    <div style={{ width: "85%" }} className="mx-auto">
      <div>
        {isSubmit === true && (
          <CheckBoxField
            name="isTermsAccepted"
            onChangeHandler={changeHandler}
            isChecked={isTermsAccepted}
            id="isTermsAccepted"
            className="cursor-pointer"
            label={t(
              "I hereby declare that I have reviewed the document and confirm that I agree with all details."
            )}
          />
        )}

        <div className="row marginTop1">
          <div className="col-md-2 align-self-center">
            <Button
              className=" back-btn text-decoration-underline shadow-none bg-transparent border-0"
              handleClick={() => handleNext(false, "back")}
            >
              {t("Back")}
            </Button>
          </div>

          <div className="col-md-10">
            {isSubmit === false && (
              <>
                <div>
                  <Button
                    type="submit"
                    title={t("Next")}
                    handleClick={() => handleNext(true, "next")}
                    className="float-end form-button shadow-none marginRightPoint5"
                  />
                </div>
              </>
            )}

            {isAuthenticated && isTermsAccepted && (
              <div>
                <Button
                  type="submit"
                  title={t("Approve")}
                  handleClick={() => handleSubmit(false)}
                  className="float-end form-button shadow-none marginRightPoint5"
                />
              </div>
            )}

            {!isAuthenticated && isTermsAccepted && !isEmployer && (
              <>
                <div className="d-flex align-items-center justify-content-end">
                  <Button
                    type="submit"
                    title={t("Sign as employer")}
                    handleClick={() => employerModal()}
                    className="float-end form-button shadow-none marginRightPoint5"
                  />
                  <Button
                    type="submit"
                    title={t("Send to employer")}
                    handleClick={() => sendToEmployerModal()}
                    className="float-end form-button shadow-none marginRightPoint5"
                  />
                  {isFeeBased !== "1" && (
                    <Button
                      type="submit"
                      title={t("Send to Bright")}
                      handleClick={handleSendToBright}
                      className="float-end form-button shadow-none marginRightPoint5"
                    />
                  )}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      downloadAuthedFile(
                        `/api/admin-fiche/download/${agreementId}/${adminFicheId}?lang=${langKey}`,
                        `admin_fiche_${agreementId}_${adminFicheId}.pdf`,
                        process.env.REACT_APP_COMPANY_SERVICE
                      );
                    }}
                    className="float-end form-button shadow-none marginRightPoint5 d-flex align-items-center justify-content-center"
                  >
                    {t("Download")}
                  </a>
                  <Button
                    type="submit"
                    title={t("Upload")}
                    handleClick={handleUpload}
                    className="float-end form-button shadow-none marginRightPoint5"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionButtonsSection;
